<af-full-table class="w-100 h-100"
               [showImport]="false"
               [showExport]="false"
               [filterFields]="filterFields"
               [filterEvent]="filterEvent"
               placeholderContext="history"
               additionalSpinnerIds="history"
               [dataSource]="dataSource"
               [pageEvent]="pageEvent"
               [totalElements]="totalElements"
               (tableUpdateListener)="loadPage($event)"/>
